import { useEffect } from "react";
import { IonCard, IonCardContent } from "@ionic/react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import WithNavigation from "../../hoc/with-navigation";
import TvmForm from "../../components/common/tvm-form";
import { useSystem } from "../../store/system";
import { TvmFormSubmitResult } from "../../components/common/tvm-form/form-definition";
import { printNumber } from "../../utils/helpers";

import "./styles.css";

const FORM_ID = "flotation";

interface FlotationFormData {
	upperHeadrope: number;
	_evaluationResult: FlotationResult;
}

interface FlotationResult {
	minFlotationDemersal: number | null;
	maxFlotationDemersal: number | null;
	minBallastDemersal: number | null;
	maxBallastDemersal: number | null;
	minFlotationCrustacean: number | null;
	maxFlotationCrustacean: number | null;
	minBallastCrustacean: number | null;
	maxBallastCrustacean: number | null;
}

const Flotation = () => {
	const { systemId } = useParams<any>();
	const { t } = useTranslation();
	const systemStore = useSystem();

	const updateResults = (data: TvmFormSubmitResult<FlotationFormData>) => {
		systemStore.submitFormResult(systemId, FORM_ID, data);
	};

	useEffect(() => {
		systemStore.loadForm(FORM_ID);
		systemStore.loadFormResult(systemId, FORM_ID);
	}, []);

	return (
		<>
			<WithNavigation
				hintsContent={{
					title: systemStore.currentForm?.hints.title,
					htmlDef: systemStore.currentForm?.hints.htmlDef,
				}}
				preventGoBack={false}
				text={t("system.flotation.title")}
			>
				<div className="form">
					{systemStore.currentForm && (
						<>
							{systemStore.formResultReqInfo?.finished && (
								<TvmForm
									title={t("system.flotation.title")}
									systemName={systemId}
									definition={systemStore.currentForm}
									fieldValues={systemStore.currentFormValues}
									onSubmit={updateResults}
								/>
							)}
							{systemStore.formFlags?.demersal && (
								<>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">{t("system.flotation.minFlotationDemersal")}</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.minFlotationDemersal
														? `${printNumber(
																systemStore.formResult?.minFlotationDemersal,
																2
														  )} kgf`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">{t("system.flotation.minBallastDemersal")}</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.minBallastDemersal
														? `${printNumber(
																systemStore.formResult?.minBallastDemersal,
																2
														  )} kg`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">{t("system.flotation.maxFlotationDemersal")}</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.maxFlotationDemersal
														? `${printNumber(
																systemStore.formResult?.maxFlotationDemersal,
																2
														  )} kgf`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">{t("system.flotation.maxBallastDemersal")}</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.maxBallastDemersal
														? `${printNumber(
																systemStore.formResult?.maxBallastDemersal,
																2
														  )} kg`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
								</>
							)}
							{!systemStore.formFlags?.demersal && (
								<>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">{t("system.flotation.minFlotationCrustacean")}</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.minFlotationCrustacean
														? `${printNumber(
																systemStore.formResult?.minFlotationCrustacean,
																2
														  )} kgf`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">{t("system.flotation.minBallastCrustacean")}</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.minBallastCrustacean
														? `${printNumber(
																systemStore.formResult?.minBallastCrustacean,
																2
														  )} kg`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">{t("system.flotation.maxFlotationCrustacean")}</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.maxFlotationCrustacean
														? `${printNumber(
																systemStore.formResult?.maxFlotationCrustacean,
																2
														  )} kgf`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">{t("system.flotation.maxBallastCrustacean")}</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.maxBallastCrustacean
														? `${printNumber(
																systemStore.formResult?.maxBallastCrustacean,
																2
														  )} kg`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
								</>
							)}
						</>
					)}
				</div>
			</WithNavigation>
		</>
	);
};

export default Flotation;
